import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-art-template-info',
  imports: [TranslatePipe],
  templateUrl: './art-template-info.component.html',
  styleUrls: [
    './art-template-info.component.scss',
    '../template-shared.stylesheet.scss',
  ],
})
export class ArtTemplateInfoComponent {
  translationPrefix = input('', { transform: appendPrefix });
}
function appendPrefix(value: string | undefined): string {
  return value + 'art.';
}
